import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ theme }) => css`
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    border: 1px solid #E7EBEB;
    position: relative;
    width: 100%;
    background: linear-gradient(${`${theme.colour?.primary}0D`} 132px, #FFFFFF 132px);
    &:hover {
      cursor: pointer;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
      background: linear-gradient(${`${theme.colour?.primary}1A`} 111px, ${`${theme.colour?.primary}0D`} 111px);
    }

    @media only screen and (min-width: 768px) {
      background: linear-gradient(${`${theme.colour?.primary}0D`} 111px, #FFFFFF 111px);
      border-radius: 9px;
    }
  `}
`;

export default Wrapper(template);